import { useTranslate } from "react-admin";
import { Button, Tooltip } from "../../../../components/MuiGenerals";

interface RentButtonProps {
  onClick: () => void;
  isDisabled?: boolean;
  width?: string;
  height?: string;
}

const RentButton = (props: RentButtonProps) => {
  const translate = useTranslate();
  const t = (key: string) => translate(`tronWalletResourceBalance.${key}`);
  const { onClick, isDisabled = false, width = "60%", height = "70%" } = props;

  return (
    <Tooltip title={t("rent")}>
      <span style={{ width, height }}>
        <Button
          sx={{
            borderRadius: "18px",
            backgroundColor: "#4a90f7",
            width: "100%",
            height: "100%",
          }}
          variant="contained"
          onClick={onClick}
          disabled={isDisabled}
        >
          {t("rent")}
        </Button>
      </span>
    </Tooltip>
  );
};

export default RentButton;
